import { AppSelector } from '../store';

export const selectUser = (state: AppSelector) => state.user.entity;
export const selectProfit = (state: AppSelector) => state.user.profit;
export const selectCountries = (state: AppSelector) => state.settings.globals.countries;
export const selectUserSettings = (state: AppSelector) => state.userSettings.entity;

export const selectOverview = (state: AppSelector) => state.overview.data;
export const selectGlobals = (state: AppSelector) => state.settings.globals;
export const selectIsAdmin = (state: AppSelector) => state.cookies.isAdmin;
